import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/dashboard/components/DashboardClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/AppLayout.tsx");
